import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import RepaymentTableRecords from '../RepaymentTableRecords';

const UpcomingRepayments = () => (
  <RepaymentTableRecords defaultUrl={AdminRouteName.upcomingRepaymentRoute} tabStatus="UPCOMING" toggleStorageId="upcoming-repayment-table-col" hasNameAndImage permissionName="can-view-upcoming-repayments" />
);
export default UpcomingRepayments;
